<template>
  <CockpitDialog
    title="疏散路径"
    left="630px"
    width="690px"
    height="250px"
    top="120px"
    @close="$emit('close')"
  >
    <div class="w-full h-full" v-loading="loading">
      <el-row :gutter="15" class="w-full h-full overflow-auto">
        <el-col v-for="(item, index) in formConfig" :key="index" :span="8">
          <div class="h-30px leading-30px flex justify-start items-center">
            <div class="inline-block w-100px">{{ item.label }}：</div>
            <el-tooltip :content="item.value + ''">
              <div class="inline-block flex-1 truncate">
                {{ item.value }}
              </div>
            </el-tooltip>
          </div>
        </el-col>
      </el-row>
    </div>
  </CockpitDialog>
</template>

<script>
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import { EvacuatePathApi } from '@wiz-api/emergency-management'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const areaApi = new AreaApi()
const evacuatePathApi = new EvacuatePathApi()

export default {
  name: 'escape-route-dialog',
  data() {
    return {
      loading: false,
      formConfig: [
        {
          label: '疏散路径名称',
          field: 'name',
          value: '',
        },
        {
          label: '路径编码',
          field: 'code',
          value: '',
        },
        {
          label: '所属区域',
          field: 'areaId',
          value: '',
        },
      ],
      areaList: [],
    }
  },
  components: {
    CockpitDialog,
  },
  props: {
    propData: {
      type: Object,
      defalut: () => {},
    },
  },
  watch: {
    'propData.id': {
      async handler(newVal) {
        await this.getDetail(newVal)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * 获取详情
     */
    async getDetail(id) {
      this.loading = true
      const [err, res] = await evacuatePathApi.getInfo({ id })
      if (!err) {
        this.formConfig.forEach(async (item) => {
          const keys = Object.keys(res)
          if (keys.includes(item.field)) {
            if (item.field === 'areaId') {
              item.value = await this.getAreaDetail(res.areaId)
            } else {
              item.value = res[item.field]
            }
          }
        })
      }
      this.loading = false
    },
    /**
     * 获取区域详情
     */
    async getAreaDetail(id) {
      let areaName = ''
      const [err, res] = await areaApi.get(id, { id })
      if (!err) {
        areaName = res.name
      }
      return areaName
    },
  },
}
</script>

<style scoped lang="scss"></style>
